import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import FormControlLabel from "@mui/material/FormControlLabel";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@material-ui/core/Popper";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import AssignGroupDialog from "./AssignGroup.js";

import { CREATE_TENANT_USER_MUTATION } from "../../graphQL/user_qry";
import { GET_TENANT_DATA_BY_USER } from "../../graphQL/tenant_qry";
import { CLIENT_GROUP_LIST_QUERY } from "../../graphQL/group_qry";

import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const PopperMy = function (props) {
  return <Popper {...props} style={styles.popper} placement="bottom-start" />;
};
const styles = theme => ({
  popper: {
    width: "fit-content",
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  largeButtonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  datePickerStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
}));

function UserAdd() {
  const [loadContent, setLoadContent] = useState(false);
  const [alertMsg, setAlertMsg] = useState([]);
  const [selectedStateVal, setSelectedStateVal] = useState("Select");
  const [selectedCountryVal, setSelectedCountryVal] = useState("Select");
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedGroupsByClient, setSelectedGroupsByClient] = useState([]);
  const [showAssignGroupDialog, setShowAssignGroupDialog] = useState(false);
  const [tenantStates, setTenantStates] = useState([]);
  const [tenantCountries, setTenantCountries] = useState([]);
  const [errorMsg, setErrorMsg] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  const classes = useStyles();
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    control
  } = useForm();

  
  const [createTenantUser] = useMutation(CREATE_TENANT_USER_MUTATION, {
    awaitRefetchQueries: true,
  });
  const [getUserTenantData] = useManualQuery(GET_TENANT_DATA_BY_USER, {
    fetchPolicy: "network-only",
  });
  
  const getTenant = async () => {
    // Get tenant information
    const {
      loading: tenantDataLoading,
      error: tenantDataError,
      data: tenantData,
    } = await getUserTenantData();

    if (!tenantDataLoading && tenantData && tenantData.getUserTenantData) {
      setTenantStates(tenantData.getUserTenantData.statesList.map(({ name }) => name));
      setTenantCountries(
        tenantData.getUserTenantData.countriesList.map(({ name }) => name)
      );
    }
    if (tenantDataError) {
      console.log(tenantDataError);
      if (
        tenantDataError.graphQLErrors &&
        tenantDataError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };
  
  const handleDoneAssignGroups = (selectedGroups, selectedGroupsByClient) => {
    console.log("Selected groups:", selectedGroups);
    setSelectedGroups(selectedGroups);
    setSelectedGroupsByClient(selectedGroupsByClient);
  };
  
  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  let clientName = "";
  if (localStorage.getItem("clientName"))
    clientName = localStorage.getItem("clientName");

  const [addAccess, setAddAccess] = useState(true);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Staff",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      
      
      if(commonActions.find(a => a == "Add")){
        setAddAccess(true); }
      else { setAddAccess(false); }
      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTenant())();
  }, []); 

  const onSubmit = async formData => {
   
   if (selectedGroups.length > 0 ){
    const { data, error } = await createTenantUser({
      variables: {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phoneNo: formData.phone,
        city: formData.city,
        state: formData.state,
        country: formData.country,
        tenantId: parseInt(tenantId),
        groups: selectedGroups,
      },
    });
    if (error) {
      console.log("Error", error, data);
      setAlertMsg({
        title: "Error",
        msg: error.graphQLErrors[0].message,
      });
    } else if (data && data.createTenantUser) {
      console.log("Success", data);
      setAlertMsg({
        title: "Success",
        msg: "New staff has been successfully added.",
      });
    }
   }
   else
   {
    setAlertMsg({
        title: "",
        msg: 'You must select at least one group before you can save this staff record. Click the "Assign Group" button',
      });
    
   }
  };
  
  if (loadContent)
    if (addAccess)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: "Add Staff", link: null }]} />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="body1" style={{ marginBottom: 10 }}>
              Add Staff
            </Typography>
          </Box>
          <Divider />
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid
              container
              spacing={3}
              style={{
                marginTop: 20,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid item xs={1}>
                <Button
                  variant="contained"
                  size="large"
                  className={classes.largeButtonStyle}
                  onClick={() => setShowAssignGroupDialog(true)}
                >
                  Assign Groups
                </Button>
              </Grid>
              <Grid item xs={4} style={{ textAlign: 'left', margin: '0'}}>  
                {Object.keys(selectedGroupsByClient).length === 0 ? (
                  <ul style={{ textAlign: 'left', marginLeft: '0', paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '10px' }}>
                      <Typography variant="h3" style={{ fontSize: 16 }}>
                        You must select at least one group
                      </Typography>
                    </li>
                  </ul>
                ) : (              
                  <ul style={{ textAlign: 'left', marginLeft: '0', paddingLeft: '20px' }}>
                    {Object.entries(selectedGroupsByClient).map(([client, groups]) => (
                      
                      <li key={client} style={{ marginBottom: '10px' }}>
                        <Typography variant="h3" style={{ fontSize: 16 }}>Client: {client} --> Groups: {groups.join(", ")}</Typography>
                      </li>
                    ))}
                  </ul>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="First Name"
                  margin="normal"
                  name="firstName"
                  type="name"
                  variant="outlined"
                  id="firstName"
                  {...register("firstName", { required: true })}
                />

                {errors.firstName && errors.firstName.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    First name cannot be blank.
                  </FormHelperText>
                )}

                {errorMsg.firstName && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.firstName}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="Last Name"
                  margin="normal"
                  name="name"
                  type="name"
                  variant="outlined"
                  id="lastName"
                  {...register("lastName", { required: true })}
                />

                {errors.lastName && errors.lastName.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Last name cannot be blank.
                  </FormHelperText>
                )}

                {errorMsg.lastName && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.lastName}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="Email"
                  margin="normal"
                  name="email"
                  type="email"
                  variant="outlined"
                  id="email"
                  {...register("email", {
                    required: true,
                    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  })}
                />

                {errors.email && errors.email.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Email cannot be blank.
                  </FormHelperText>
                )}

                {errorMsg.email && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.email}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="Phone Number"
                  margin="normal"
                  name="phone"
                  type="phone"
                  variant="outlined"
                  id="phone"
                  {...register("phone")}
                />
                {errorMsg.phone && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.phone}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="City"
                  margin="normal"
                  name="city"
                  type="text"
                  variant="outlined"
                  id="city"
                  {...register("city")}
                />
                {errorMsg.city && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.city}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  className={classes.autoComStyle}
                  key={selectedStateVal}
                  options={tenantStates}
                  PopperComponent={PopperMy}
                  getOptionLabel={option => option}
                  renderInput={params => (
                    <TextField
                      fullWidth
                      label="State"
                      margin="normal"
                      name="selectState"
                      variant="outlined"
                      {...params}
                      id="state"
                      {...register("state")}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <form noValidate autoComplete="off">
                  <Autocomplete
                    className={classes.autoComStyle}
                    key={selectedCountryVal}
                    options={tenantCountries}
                    PopperComponent={PopperMy}
                    getOptionLabel={option => option}
                    renderInput={params => (
                      <TextField
                        fullWidth
                        label="Country"
                        margin="normal"
                        name="selectCountry"
                        variant="outlined"
                        {...params}
                        id="country"
                        {...register("country")}
                      />
                    )}
                  />
                </form>
              </Grid>
            </Grid>
            <Box pt={4} pb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                type="submit"
              >
                Save
              </Button>

              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={() => navigate(`${project_url}/staff`)}
              >
                Cancel
              </Button>
            </Box>
          </form>
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
                alertMsg.title === "Success" && navigate(`${project_url}/staff`);
              }}
            />
          )}
          {showAssignGroupDialog && (
            <AssignGroupDialog
              closeDialog={() => setShowAssignGroupDialog(false)}
              onDone={(selectedGroups, selectedGroupsByClient) =>
                         handleDoneAssignGroups(
                          selectedGroups, selectedGroupsByClient)
                     }
              preSelectedGroups={selectedGroups}
              preSelectedGroupsByClient={selectedGroupsByClient}
              //selectedGroupIds={(groupIds) =>handleDoneAssignGroups(groupIds)}
            />
          )}
        </div>
      </div>
    );
  
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default UserAdd;
